import { TaxRegistration } from "@/gql/graphql";

const TAX_RATES: Record<TaxRegistration, number> = {
  [TaxRegistration.None]: 0,
  [TaxRegistration.GstAu]: 0.1,
  [TaxRegistration.GstNz]: 0.15,
  [TaxRegistration.GstCa]: 0.05,
  [TaxRegistration.HstCa]: 0.13,
  [TaxRegistration.VatAt]: 0.2,
  [TaxRegistration.VatBe]: 0.21,
  [TaxRegistration.VatBg]: 0.2,
  [TaxRegistration.VatHr]: 0.25,
  [TaxRegistration.VatCy]: 0.19,
  [TaxRegistration.VatCz]: 0.21,
  [TaxRegistration.VatDk]: 0.25,
  [TaxRegistration.VatEe]: 0.22,
  [TaxRegistration.VatFi]: 0.255,
  [TaxRegistration.VatFr]: 0.2,
  [TaxRegistration.VatDe]: 0.19,
  [TaxRegistration.VatGr]: 0.24,
  [TaxRegistration.VatHu]: 0.27,
  [TaxRegistration.VatIe]: 0.23,
  [TaxRegistration.VatIt]: 0.22,
  [TaxRegistration.VatLv]: 0.21,
  [TaxRegistration.VatLt]: 0.21,
  [TaxRegistration.VatLu]: 0.17,
  [TaxRegistration.VatMt]: 0.18,
  [TaxRegistration.VatNl]: 0.21,
  [TaxRegistration.VatPl]: 0.23,
  [TaxRegistration.VatPt]: 0.23,
  [TaxRegistration.VatRo]: 0.19,
  [TaxRegistration.VatSk]: 0.23,
  [TaxRegistration.VatSi]: 0.22,
  [TaxRegistration.VatEs]: 0.21,
  [TaxRegistration.VatSe]: 0.25,
};

export function getTaxRate(registration: TaxRegistration): number {
  return TAX_RATES[registration] ?? 0;
}

export function addTax(amount: number, registration: TaxRegistration): number {
  const rate = getTaxRate(registration);
  return amount + Math.round(amount * rate);
}

export function removeTax(
  amountIncTax: number,
  registration: TaxRegistration,
): number {
  const rate = getTaxRate(registration);
  if (rate === 0) return amountIncTax;
  const excTax = Math.round(amountIncTax / (1 + rate));
  if (addTax(excTax, registration) === amountIncTax) return excTax;
  if (addTax(excTax - 1, registration) === amountIncTax) return excTax - 1;
  if (addTax(excTax + 1, registration) === amountIncTax) return excTax + 1;
  return excTax;
}
